import React, { useState } from "react";
import { Box, Button, Column, Columns, Control, Field, Pagination, Table } from "@allxsmith/bestax-bulma";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh, getWorkLookupData} from "../../state/selectors";
import WorkLookupRow from "./WorkLookupRow";
import {createSetWorkLookupDataAction,} from "../../actions/dataActions";
import {useWorkLookupsData} from "../../hooks/useWorkLookupsData";
import CreateWorkModal from "./CreateWorkModal";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";
import SearchBar from "../Utils/SearchBar";
import Nav from "../Nav/Nav";
import LoadingSpinner from "../Utils/Spinner";
import PaginationWrapper from "../Utils/PaginationWrapper";

function WorkLookup(props) {
  const [searchText, setSearchText] = useState("");
  const [filters, setFilters] = useState({});
  const [search, setSearch] = useState(null);
  const [page, setPage] = useState(1);
  const dataFresh = useSelector(getDataFresh);
  const dispatch = useDispatch();

  const [createWorkModalOpen, setCreateWorkModalOpen] = useState(false);

  const headings = [
    {
      label: "Description",
    },
    {
      label: "Labour Hours",
    },
    {
      label: "Labour Cost",
    },
    {
      label: "Customer Labour Charge"
    },
    {
      label: "Supplier",
      field: "supplier",
      labelField: "supplier__display_name"
    },
    {
      label: "Default Item",
      field: "default_item",
      labelField: "default_item"
    },
    {
      label: "Number of Parts"
    }
  ];

  let params = {
    page,
    search,
  };

  for (let filter in filters) {
    if (filters[filter][0] && filters[filter][0][filter]) {
      params[filter] = filters[filter][0][filter];
    }
  }

  const complete = useWorkLookupsData(params, dataFresh);
  const data = useSelector(getWorkLookupData);

  const updateValue = (index, newWork) => {
    let newResults = [...data.results]
    let currentData = { ...data, results: newResults };
    currentData.results[index] = newWork;
    dispatch(createSetWorkLookupDataAction(currentData));
  };

  if (!complete){
    return (
        <div>
          <Nav/>
          <LoadingSpinner/>
        </div>
    )
  }

  document.title = "Work Stock";

  const clear = e => {
    setSearch("");
    setSearchText("");
  };
  const handleSearch = e => {
    setPage(1);
    setSearch(searchText);
  }

  // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
  return (
    <div>
      <Nav/>
      <br/>
      <br/>
      <Box>
        <Columns isMultiline>
          <Column>
            <label className="label">Work Search</label>
            <SearchBar
              handleSearch={handleSearch}
              clear={clear}
              setSearchText={setSearchText}
              searchText={searchText}
              inputTestId={"work-search"}
              searchButtonTestId={"search-button"}
            />
          </Column>
          <Column>
            <Field>
              <Control>
                <Button
                  onClick={() => setCreateWorkModalOpen(true)}
                  color="success"
                  className="is-pulled-right"
                >
                  New Work +
                </Button>
              </Control>
            </Field>
          </Column>
        </Columns>
      </Box>
      <Box>
        <Table isFullwidth>
          <thead>
            <tr>
              {headings.map(heading => {
                if (!heading.field) {
                  return <th key={heading.label}>{heading.label}</th>;
                }
                if (heading.blank) {
                  return (
                    <FilterBlankHeading
                      key={heading.label}
                      heading={heading}
                      setFilters={f => {
                        setPage(1);
                        setFilters(f);
                      }}
                      filters={filters}
                    />
                  );
                }
                return (
                  <FilterHeading
                    key={heading.label}
                    heading={heading}
                    setFilters={f => {
                      setPage(1);
                      setFilters(f);
                    }}
                    filters={filters}
                    options={data.filter_list[heading.field]}
                  />
                );
              })}
              {/*<th>Make</th>*/}
              {/*<th>Model</th>*/}
              {/*<th>Type</th>*/}
              {/*<th>Work Name</th>*/}
              {/*<th>Work Number</th>*/}
              {/*<th>Work Cost</th>*/}
              {/*<th>Supplier</th>*/}
              {/*<th>Stock Volume</th>*/}
              {/*<th>Comments</th>*/}
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.results.map((work, index) => (
              <WorkLookupRow
                key={work.id}
                workLookup={work}
                endpoint={props.endpoint}
                updateValue={newWork => updateValue(index, newWork)}
              />
            ))}
          </tbody>
        </Table>
        <PaginationWrapper
          setPage={setPage}
          page={page}
          dataCount={Math.ceil(data.count / 25)}
        ></PaginationWrapper>
      </Box>
      <CreateWorkModal
        open={createWorkModalOpen}
        setOpen={setCreateWorkModalOpen}
        endpoint={props.endpoint}
      />
    </div>
  );
}

export default WorkLookup;
